import React from 'react';
import { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useCarrito } from './component/Cart';

const FinalizarPago = () => {
    const location = useLocation();
    const history = useHistory();
    const { clearCarrito } = useCarrito();
    const [mensaje, setMensaje] = useState('Procesando el pago…');

    const [usuario] = useState(() => {
        const usuarioAlmacenado = localStorage.getItem("userLogueado");
        return usuarioAlmacenado ? JSON.parse(usuarioAlmacenado) : null;
    });

    let baseUrl;
    if(process.env.NODE_ENV === 'development') baseUrl = 'http://localhost:8080';
    else baseUrl='https://app-formacion.vercel.app';
    
    useEffect(() => {

      const consulta = new URLSearchParams(location.search);
      const sesionId = consulta.get('session_id');
      const compraId = consulta.get("compraId");

      if (!sesionId || !usuario || !compraId) {
        history.replace('/');
        return;
      }

      const finalizar = async () => {
        try {
            const res = await fetch(`${baseUrl}/api/pago/finalizar/${sesionId}/${compraId}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ usuarioId: usuario._id })
            });

            if (!res.ok) {
                throw new Error('Error al finalizar la compra.');
            }
            
            const datos = await res.json();

            if(datos.compraId && datos.productos){
              clearCarrito();
              history.replace(`/compra/exitosa/${datos.compraId}`);
            }
            else{
              history.replace('/pago/error');
              throw new Error('Respuesta de error por parte del servidor');
            }
                
        } catch(error){
          console.error(error);
          history.replace('/pago/error');
        }
      };

      finalizar();
  }, [location, history, clearCarrito, usuario]);

  return (
    <div style={{ 
            minHeight: 'calc(100vh - 100px)', 
            paddingTop: '60px', 
            background: 'var(--bg-home)' 
            }} >
      <p style={{ color: 'var(--text-principal)', textAlign: "center", fontStyle: "italic", marginTop: "2rem" }}>{mensaje}</p>
    </div>
  )
}

export default FinalizarPago;